<script lang="ts">
  import type { VideoAdTopProps } from '$src/js/_types/VideoAd';
  import BaseModule from '$src/js/app/base/BaseModule';
  import Svg from '$src/js/components/_base/svg/Svg.svelte';
  import { onMount } from 'svelte';

  let { videoAdTopData, onSendPageView }: VideoAdTopProps = $props();

  let partnerElement = $state<HTMLAnchorElement>();
  let videoElement = $state<HTMLVideoElement | null>(null);
  let isMuted = $state(true);

  const handleToggleMute = () => {
    if (!videoElement) {
      return;
    }

    isMuted = !isMuted;
    videoElement.muted = isMuted;
  };

  $effect(() => {
    setTimeout(() => {
      if (partnerElement) {
        document.documentElement.style.setProperty(
          '--partner-element-height',
          partnerElement.offsetHeight.toString() + 'px',
        );
      }
    }, 200);
  });

  onMount(() => {
    onSendPageView();
  });
</script>

<div class="relative">
  <div
    class="fixed top-0 left-0 h-[70svh] w-full max-lg:h-[calc(56.25vw_+_var(--partner-element-height)_+_64px)]"
    id="video-ad-top"
  >
    <div class="absolute top-0 left-0 h-full w-full">
      <video
        class=" h-[100%] w-[100%] object-cover opacity-40 blur-3xl"
        muted
        autoplay
        playsinline
        loop
      >
        <source src={videoAdTopData.video.url} type="video/mp4" />
      </video>
    </div>

    <div class="relative w-full py-6 lg:aspect-video lg:h-full">
      <video
        bind:this={videoElement}
        class="h-full w-full max-lg:aspect-video"
        muted
        autoplay
        playsinline
        loop
      >
        <source src={videoAdTopData.video.url} type="video/mp4" />
      </video>
    </div>
  </div>

  <div
    class="relative h-[70svh] w-full max-lg:h-[calc(56.25vw_+_var(--partner-element-height)_+_64px)]"
  >
    <a
      bind:this={partnerElement}
      href={videoAdTopData.cta.url}
      target="_blank"
      class="group bg-surface-neutral-def-base/20 hover:bg-surface-neutral-def-base/60 transition-200 absolute bottom-6 left-4 mr-18 flex max-w-[320px] items-center gap-4 rounded-xl px-6 py-4 transition-all lg:bottom-4 xl:left-8"
    >
      <img class="h-12 w-12 object-cover" alt="Ad" src={videoAdTopData.cta.image} />

      <div class="flex flex-col gap-2">
        <span class="text-11asrem leading-[130%] italic">
          {BaseModule.getInstance().i18n.translate('advertisement')}
        </span>

        <h2 class="text-15asrem leading-[130%] font-semibold">{videoAdTopData.cta.title}</h2>
        <p class="text-11asrem leading-[130%] group-hover:underline">
          {videoAdTopData.cta.label} >
        </p>
      </div>
    </a>

    <button
      class="bg-surface-neutral-def-base/20 hover:bg-surface-neutral-def-base/60 transition-200 absolute right-4 bottom-4 flex h-10 w-10 items-center justify-center rounded-full transition-all xl:right-8"
      onclick={handleToggleMute}
    >
      {#if isMuted}
        <Svg icon="audio-off" size="20" className="fill-current" />
      {:else}
        <Svg icon="audio-on" size="20" className="fill-current" />
      {/if}
    </button>
  </div>
</div>
